import React, { useState } from "react";
import Whatsapp from '../../assets/whtapp.png';

export default function WhatsAppModal({whatsappnum,setWhatsappnum,handleTicket,setOpenWhatsappModal}) {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("error");

  const validatePhone = (number) => {
    // Allow only digits, must be 10 to 15 digits (for international numbers)
    const regex = /^\d{10,15}$/;
    return regex.test(number);
  };

  const handleSubmit = () => {
    if (!validatePhone(whatsappnum)) {
      setError("Enter a valid mobile number.");
      return;
    }
    setError("error");
    //console.log("Phone number:", whatsappnum);
    // Add your submit logic here
   handleTicket()
  };

  const handleCancel = () => {
    setPhone("");
    setError("error");
    setOpenWhatsappModal(false)
  };

  const handleNumber = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
    if (value.length <= 10) {
      setWhatsappnum(value);
      if (error !== "error") setError("error");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50" style={{ padding: "5%" }}>
      <div className="bg-white rounded-lg p-6 w-96 shadow-lg relative">
        <div className="flex justify-center -mt-20 mb-4">
          <img
            src={Whatsapp}
            alt="WhatsApp Logo"
            className="w-[102px] h-[102px] rounded-full p-1"
          />
        </div>
        <h2 className="text-center text-lg font-semibold mb-2">
          Enter Your What’s App Number
        </h2>
        <p className="text-sm text-gray-600 text-center mb-4">
          We'll use this to raise your support ticket and keep you updated
        </p>
        <input style={{marginLeft:"0",width:"100%"}}
          type="number"
          placeholder="Please Enter Number"
          value={whatsappnum}
       maxLength={10}
          onChange={(e) => {handleNumber(e)
          
            if (error) setError("error"); // clear error on input change
          }}
          className={`w-full border ${error=="error" ?'border-gray-300': 'border-red-500' } rounded px-4 py-2 mb-2 focus:outline-none focus:ring-2 focus:ring-green-500`}
        />
        {<p className="text-red-500 text-sm mb-2" style={{opacity:error=="error"?0:1}}>{error}</p>}
        <div className="flex justify-between" style={{marginTop:"5vw"}}>
          <button
            style={{ textAlign: "center", border: "2px solid #00B177" }}
            onClick={handleCancel}
            className="w-1/2 mr-2 border border-green-500 text-green-500 py-2 rounded"
          >
            Cancel
          </button>
          <button
            style={{ textAlign: "center", background: "#00B177" }}
            onClick={handleSubmit}
            className="w-1/2 ml-2 text-white py-2 rounded"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
